import script from "./Package.vue?vue&type=script&setup=true&lang=js"
export * from "./Package.vue?vue&type=script&setup=true&lang=js"

import "./Package.vue?vue&type=style&index=0&id=0a531b38&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a531b38"]])

export default __exports__